import React, { useEffect, useState } from 'react';
import { X, Plus } from 'lucide-react';
import { api } from '../context/AuthContext';
import { Seite, Meldung, fehler } from '../components/stammakte/ui';

const Liste = ({ titel, werte, standard, onChange, testId }) => {
  const [neu, setNeu] = useState('');
  const add = () => { if (neu.trim()) { onChange([...werte, neu.trim()]); setNeu(''); } };
  return (
    <div data-testid={testId}>
      <p className="text-[13px] font-semibold text-[#56616D] mb-1.5">{titel}</p>
      <ul className="divide-y divide-[#10243A]/[0.07]">
        {werte.map((w, i) => (
          <li key={`${w}-${i}`} className="flex items-center gap-2 py-2 text-[15px] text-[#15202B]">
            <span className="flex-1 min-w-0 break-words">{w}</span>
            {standard.includes(w) ? <span className="text-[11.5px] text-[#9AA5B1]">Standard</span> : <span className="text-[11.5px] text-[#B8893D]">Ergänzung</span>}
            <button type="button" onClick={() => onChange(werte.filter((_, k) => k !== i))} aria-label="Entfernen" className="text-[#9AA5B1] hover:text-rose-600" data-testid={`${testId}-weg-${i}`}><X className="w-4 h-4" /></button>
          </li>
        ))}
      </ul>
      <div className="flex gap-2 mt-2">
        <input value={neu} onChange={(e) => setNeu(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder="Eigene Ergänzung" className="flex-1 min-w-0 border border-[#DCE3EA] rounded-[10px] px-3 py-2 text-[14px]" data-testid={`${testId}-neu`} />
        <button type="button" onClick={add} className="shrink-0 inline-flex items-center gap-1 h-[38px] px-3 rounded-[10px] border border-[#DCE3EA] bg-[#EEF2F6] text-[14px] font-semibold text-[#15202B]" data-testid={`${testId}-add`}><Plus className="w-4 h-4" />Hinzufügen</button>
      </div>
    </div>
  );
};

const Gebiet = ({ v, onSaved }) => {
  const [msg, setMsg] = useState('');
  const speichern = async (feld, werte) => {
    setMsg('');
    try { onSaved((await api.put(`/kanzlei/vorlagen/${v.gebiet}`, { [feld]: werte })).data); setMsg('Gespeichert – gilt ab sofort für neue Termine und Akten.'); } catch (e) { setMsg(fehler(e)); }
  };
  return (
    <section className="bg-white border border-[#DCE3EA] rounded-[14px] p-5 space-y-5" data-testid={`vorlage-${v.gebiet}`}>
      <h2 className="font-serif text-[22px] text-[#15202B]">{v.label}</h2>
      <Liste titel="Leitfaden für das Gespräch" werte={v.leitfaden} standard={v.standard_leitfaden} onChange={(w) => speichern('leitfaden', w)} testId={`vorlage-${v.gebiet}-leitfaden`} />
      <Liste titel="Unterlagen" werte={v.unterlagen} standard={v.standard_unterlagen} onChange={(w) => speichern('unterlagen', w)} testId={`vorlage-${v.gebiet}-unterlagen`} />
      <Meldung text={msg} testId={`vorlage-${v.gebiet}-msg`} />
    </section>
  );
};

export default function KanzleiVorlagen() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/kanzlei/vorlagen').then((r) => setItems(r.data.items)); }, []);
  return (
    <Seite titel="Vorlagen" text="Leitfaden und Unterlagenliste je Rechtsgebiet. Eigene Ergänzungen gelten ab sofort für alle neuen Termine dieses Rechtsgebiets." testId="vorlagen-page">
      {(items || []).map((v) => <Gebiet key={v.gebiet} v={v} onSaved={(n) => setItems((all) => all.map((x) => (x.gebiet === n.gebiet ? n : x)))} />)}
    </Seite>
  );
}
